import { idb } from "../../root/idb.js";
import { incomingMessagesTypes } from "../../root/modules/incoming-messages/data/incoming-messages-types.js";
import { log } from "../../root/modules/logs/log.js";

const previousAlertWindowForCaseOpenLog = log(
  "PREVIOUS_ALERT_WINDOW_FOR_CASE_OPEN"
);

export const isPreviousAlertWindowForCaseOpen = async ({ alertID, caseID }) => {
  const connection = await idb();

  let cursor = await connection
    .transaction("incomingMessages", "readonly")
    .store.index("timestamp")
    .openCursor(undefined, "prev");

  let count = 0;

  while (cursor) {
    count += 1;

    let { value: incomingMessage } = cursor;

    if (
      incomingMessage.caseID === caseID &&
      incomingMessage.id !== alertID &&
      incomingMessage.type === incomingMessagesTypes.Alert
    ) {
      const result = !incomingMessage.dismissed;

      previousAlertWindowForCaseOpenLog.info(
        `previous alert window for case ${caseID} is ${result} (found in ${count})`
      );

      return result;
    }

    cursor = await cursor.continue();
  }

  return false;
};
